import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';

import { Counter } from 'components';
import { Icon } from 'elements';
import { GetCategory, GetCompany } from 'query';
import { classnames, classname } from 'utils';

import './Company.css';

class Company extends Component {
  cl = classname('company');

  render() {
    const { className, title, categories, rating, link } = this.props;

    const classes = classnames(className, this.cl());

    const categoriesBindKey = categories.reduce((list, item) => ({ ...list, [item.id]: item }), {});

    const fullTitle = title + ' – AdIndex. Technology Map 2020';

    return (
      <div className={classes}>
        <Helmet>
          <title>{fullTitle}</title>
          <meta property="og:title" content={fullTitle} />
        </Helmet>
        {link ? (
          <a href={link} className={this.cl('name')} target={'_blank'}>
            {title}
            <Icon name={'link'} className={this.cl('link')} />
          </a>
        ) : (
          <div className={this.cl('name')}>{title}</div>
        )}

        <div className={this.cl('ratings')}>
          {categories.map(category => {
            if (!rating || !rating[category.id]) return;

            const item = rating[category.id];

            if (!Object.values(item).some(item => item !== null)) return;

            return (
              <div className={this.cl('rating')}>
                <div className={this.cl('title')}>
                  <Link to={category.uri}>{categoriesBindKey[category.id].title}</Link>
                </div>
                <div className={this.cl('list')}>
                  {Object.keys(item)
                    .filter(key => item[key] !== null && key !== "values")
                    .map(key => (
                      <>
                        <div className={this.cl('counter')}>
                          <Counter uri={category.uri} values={item.values}>{item[key]}</Counter>
                        </div>
                        <Link to={category.uri + key + '/'} className={this.cl('item')}>
                          <div className={this.cl('text')}>{categoriesBindKey[category.id].groups[key].title}</div>
                        </Link>
                      </>
                    ))}
                </div>
              </div>
            );
          })}
        </div>

        {/*<div className={this.cl('addition')}>*/}
        {/*  <div className={this.cl('addition-description')}>Материал о компании</div>*/}
        {/*  <div className={this.cl('addition-title')}>Терригенный сталагмит глазами современников</div>*/}
        {/*  <div className={this.cl('addition-text')}>*/}
        {/*    При описанных условиях текстура сдвигает биотит. Обезвоживание грунтов вызывают генезис сдвигает лавовый*/}
        {/*    поток. Эвтектика, разделенные узкими линейновытянутыми зонами выветрелых пород, деформирует пелагический*/}
        {/*    гипергенный минерал. Авгит окристаллизован. Отложение ожелезнено.  Сейчас хорошо известно, что тальвег*/}
        {/*    покрывает увалистый лавовый поток.*/}
        {/*  </div>*/}
        {/*  <a href="#" className={this.cl('addition-link')}>*/}
        {/*    Читать статью*/}
        {/*  </a>*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default ({ id }) => (
  <GetCategory>
    {categories => <GetCompany options={{ id }}>{data => <Company categories={categories} {...data} />}</GetCompany>}
  </GetCategory>
);
